import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';

const moduleRouter: RouteConfig = {
  path: '/module',
  component: Layout,
  redirect: '/module/index',
  children: [
    {
      path: '/module/index',
      name: 'Module',
      component: () => import('@/views/module/index.vue'),
      meta: {
        title: 'route.module',
        icon: 'iconmokuai0',
        activeMenu: ['/module/index'],
        breadcrumb: [
          {title: 'route.moduleList', path: '/module/index'},
        ],
      },
    },
    {
      path: '/module/create',
      name: 'CreateModule',
      props: true,
      component: () => import('@/views/module/createModule.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/module/index'],
        title: 'route.createModule',
        noCache: true,
        breadcrumb: [
          {title: 'route.moduleList', path: '/module/index'},
          {title: 'route.createModule', path: '/module/create'},
        ],
      },
    },
    {
      path: '/module/createFromTemplate',
      name: 'CreateModuleFromTemplate',
      props: true,
      component: () => import('@/views/module/createModuleFormTemplate.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/module/index'],
        title: 'route.createModule',
        noCache: true,
        breadcrumb: [
          {title: 'route.moduleList', path: '/module/index'},
          {title: 'route.createModule', path: '/module/createFromTemplate'},
        ],
      },
    },
    {
      path: '/module/update',
      name: 'UpdateModule',
      props: true,
      component: () => import('@/views/module/updateModule.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/module/index'],
        title: 'route.updateModule',
        noCache: true,
        breadcrumb: [
          {title: 'route.moduleList', path: '/module/index'},
          {title: 'route.updateModule', path: '/module/update'},
        ],
      },
    },
    {
      path: '/template/update',
      name: 'UpdateTemplate',
      props: true,
      component: () => import('@/views/module/updateTemplate.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/module/index'],
        title: 'route.updateTemplate',
        noCache: true,
        breadcrumb: [
          {title: 'route.moduleList', path: '/module/index'},
          {title: 'route.updateTemplate', path: '/template/update'},
        ],
      },
    },
    {
      path: '/template/create',
      name: 'CreateTemplate',
      props: true,
      component: () => import('@/views/module/createTemplate.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/module/index'],
        title: 'route.createTemplate',
        noCache: true,
        breadcrumb: [
          {title: 'route.moduleList', path: '/module/index'},
          {title: 'route.updateTemplate', path: '/template/update'},
        ],
      },
    },
  ],
};

export default moduleRouter;
